import { createContext } from 'react';
import { EmissionSpoolsType } from './emissionSpoolsType';

const emissionSpoolsContext = createContext({} as EmissionSpoolsType);

export default emissionSpoolsContext;
